import React, { useCallback, useState } from 'react'
import context from '@/context'
import { ModalBody, Form, FormGroup, Label, Row, Col } from 'reactstrap'
import Resx from '@/components/Resx'
import { DropDownList } from '@/components/dropDownList'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { EnumDropDownList } from '@/components/enumDropDownList'
import { institutionTypes } from '@/enums/institutionTypes'
import { intMaxValue } from '@/utils/constants'

const ReportGroupPermissionDialog = React.memo(function ReportGroupPermissionDialog ({ reportGroupPermission, onAction, dataIndex, ...props }) {
  const { id, jobPositionAssignmentId } = reportGroupPermission

  const [institutionType, setInstitutionType] = useState(reportGroupPermission.institutionType || null)
  const [institution, setInstitution] = useState(reportGroupPermission.institution || null)
  const [bankType, setBankType] = useState(reportGroupPermission.bankType || null)
  const [companyType, setCompanyType] = useState(reportGroupPermission.companyType || null)
  const [reportGroup, setReportGroup] = useState(reportGroupPermission.reportGroup || null)

  const institutionTypeChange = useCallback(e => setInstitutionType((e && e.value) || null), [])
  const institutionChange = useCallback((e) => setInstitution(e.item), [])
  const bankTypeChange = useCallback((e) => setBankType(e.item), [])
  const companyTypeChange = useCallback((e) => setCompanyType(e.item), [])
  const reportGroupChange = useCallback((e) => setReportGroup(e.item), [])

  const onSave = useCallback(() => {
    onAction({
      item: {
        id,
        jobPositionAssignmentId,
        institutionType,
        institution,
        bankType,
        companyType,
        reportGroup
      },
      dataIndex
    })
  }, [onAction, id, jobPositionAssignmentId, institutionType, institution, bankType, companyType, reportGroup, dataIndex])

  const institutionDataSource = useCallback((req) => context.api.institutionService.getLookup(req), [])
  const reportGroupsDataSource = useCallback((req) => context.api.reportGroupsService.getReportGroups(req), [])
  return (
    <ValidationBoundary>
      <BasicHeader title='Permissions.ReportGroup' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <Row>
              <Col>
                <FormGroup>
                  <Label><Resx name='Permissions.InstitutionType' /></Label>
                  <EnumDropDownList
                    enumDefinition={institutionTypes} allowClear
                    onChange={institutionTypeChange}
                    value={institutionType}
                  />
                </FormGroup>
                <FormGroup>
                  <Label><Resx name='Permissions.Institution' /></Label>
                  <DropDownList
                    dataSource={institutionDataSource}
                    onChange={institutionChange}
                    value={institution}
                  />
                </FormGroup>
                {institutionType !== institutionTypes.enum.Company && <FormGroup>
                  <Label><Resx name='Permissions.BankType' /></Label>
                  <DropDownList
                    dataSource={context.cache.getBankTypes}
                    onChange={bankTypeChange}
                    value={bankType}
                  />
                </FormGroup>}
                {institutionType !== institutionTypes.enum.Bank && <FormGroup>
                  <Label><Resx name='Permissions.CompanyType' /></Label>
                  <DropDownList
                    dataSource={context.cache.getCompanyTypes}
                    onChange={companyTypeChange}
                    value={companyType}
                  />
                </FormGroup>}
                <FormGroup>
                  <Label><Resx name='Permissions.ReportGroup' /></Label>
                  <DropDownList
                    dataSource={reportGroupsDataSource}
                    onChange={reportGroupChange}
                    value={reportGroup}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.Save' icon='save' {...props} onAction={onSave} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
})

export const maxInt = intMaxValue

export function getInstitutionPermissions (targetId, data) {
  return !targetId ? maxInt : data.getIn(['modifiedData', 'permissions'])
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: ReportGroupPermissionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/reportGroupPermission.js